
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';


Swiper.use([Navigation, Pagination, Lazy])


export default function initGoodSlider() {

    const goodsContainer = document.querySelector('.categories__slider');

    if(!goodsContainer) return;

    new Swiper(goodsContainer, {
        slidesPerView: 1.2,
        spaceBetween: 20,
		loop: true,
        navigation: {
            nextEl: '.categories-next',
            prevEl: '.categories-prev',
        },
        breakpoints: {
            1100: {
                slidesPerView: 4.1
            },
            990: {
                slidesPerView: 3.1
            },
            720: {
                slidesPerView: 2.2
            },
            520: {
                slidesPerView: 1.2
            }
        }
    })
}
